import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import JourneyPage from './pages/JourneyPage';
import TraineesPage from './pages/TraineesPage';
import TraineeDetailPage from './pages/TraineeDetailPage';
import GraduationCertificate from './pages/GraduationCertificate';
import { Toaster } from './components/ui/sonner';
import './App.css';

function AuthenticatedLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-white">
      <Sidebar />
      <main className="ml-64 flex-1 p-8">{children}</main>
    </div>
  );
}

function ProtectedPage({ children }) {
  return (
    <ProtectedRoute>
      <AuthenticatedLayout>{children}</AuthenticatedLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<ProtectedPage><DashboardPage /></ProtectedPage>} />
          <Route path="/journey" element={<ProtectedPage><JourneyPage /></ProtectedPage>} />
          <Route path="/users" element={<ProtectedPage><UsersPage /></ProtectedPage>} />
          <Route path="/trainees" element={<ProtectedPage><TraineesPage /></ProtectedPage>} />
          <Route path="/trainees/:id" element={<ProtectedPage><TraineeDetailPage /></ProtectedPage>} />
          <Route path="/certificate/:id" element={<ProtectedPage><GraduationCertificate /></ProtectedPage>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
